import { useQuery } from '@tanstack/react-query';
import { useAuthorizedFetch } from '@/lib/useAuthorizedFetch';
import { useAuth } from '@/auth';
import type { UserPreferences } from '@yhelp/shared-types';

export interface MeTenant {
  id: string;
  slug: string;
  name: string;
  plan_type: string;
  logo_url: string | null;
  primary_color: string | null;
}

export interface MeUser {
  id: string;
  email: string;
  name: string;
  role: string;
  tenant_id: string;
  preferences?: UserPreferences;
}

export function useMe() {
  const { isAuthenticated } = useAuth();
  const authorizedFetch = useAuthorizedFetch();

  return useQuery({
    queryKey: ['me'],
    queryFn: () => authorizedFetch<{ data: { user: MeUser; tenant: MeTenant | null } }>('/v1/me'),
    enabled: isAuthenticated,
  });
}
